import * as React from 'react';
import classNames from 'classnames';
import Image from '../../../Image/viewer/Image';
import { IMatrixGalleryItemProps } from '../MatrixGalleryItem.types';
import { TestIds } from '../../commons/constants';
import ItemClickActionWrapper from '../../commons/viewer/ItemClickActionWrapper/ItemClickActionWrapper';
import ImageSizer from '../../commons/viewer/ImageSizer/ImageSizer';
import Panel from './Panel';

const MatrixGalleryItem: React.FC<IMatrixGalleryItemProps> = props => {
  const {
    dataId,
    title,
    description,
    link,
    image,
    skinsStyle,
    extraClassNames,
    imageOnClickAction,
    openImageZoom = () => {},
    itemClickHandler = () => {},
    translate,
    isFocused,
    isFitMode,
  } = props;

  const openImageZoomCallback = React.useCallback(() => openImageZoom(dataId), [
    dataId,
    openImageZoom,
  ]);

  let itemRef: HTMLDivElement;
  const focusIfNeeded = (element: HTMLDivElement) => {
    if (isFocused && element) {
      element.focus();
    }
  };

  const focusItemRoot = () => {
    if (itemRef) {
      itemRef.focus();
    }
  };

  return (
    <div
      className={classNames(skinsStyle.root, extraClassNames.root, {
        [skinsStyle.fitMode]: isFitMode,
      })}
      data-testid={TestIds.item}
      onClick={itemClickHandler}
      tabIndex={-1}
      ref={(element: HTMLDivElement) => {
        itemRef = element;
        focusIfNeeded(element);
      }}
    >
      <ItemClickActionWrapper
        imageOnClickAction={imageOnClickAction}
        openImageZoom={openImageZoomCallback}
        focusItemRoot={focusItemRoot}
        link={link}
        imgTitle={image.title || ''}
        imgAlt={image.alt}
        skinsStyle={skinsStyle}
        translate={translate}
        focusDisabledItems={true}
      >
        <ImageSizer
          className={skinsStyle.imageSizer}
          isFitMode={isFitMode}
          imageWidth={image.width}
          imageHeight={image.height}
        >
          <div className={skinsStyle.imageWrapper}>
            <div className={skinsStyle.imageBorder}>
              <Image
                className={skinsStyle.image}
                id={`img_${image.containerId}`}
                {...image}
                alt={image.alt || (image.title as string)}
              />
            </div>
          </div>
        </ImageSizer>
        <Panel
          skinsStyle={skinsStyle}
          title={title}
          description={description}
        />
      </ItemClickActionWrapper>
    </div>
  );
};

export default MatrixGalleryItem;
